import { create } from 'zustand';

interface TreeSearchStore {
  searchQuery: string;
  hideEmptyLocations: boolean;
  setSearchQuery: (query: string) => void;
  setHideEmptyLocations: (hide: boolean) => void;
  clearSearch: () => void;
}

export const useTreeSearchStore = create<TreeSearchStore>((set) => ({
  searchQuery: '',
  hideEmptyLocations: true, // Default: hide empty locations
  setSearchQuery: (query) => set({ searchQuery: query }),
  setHideEmptyLocations: (hide) => set({ hideEmptyLocations: hide }),
  clearSearch: () => set({ searchQuery: '' }),
}));
